import { FaLink, FaSync } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldName, useDomFieldId } from './_useFieldName';
import { FIELD_AUTOCOMPLETE_OFF } from './_fieldDefaults';

const BLOCK = 'LStudio__app_field';

/*
    🔥 SLUG — la URL amigable

    Se genera desde otro campo (el título) pero se puede editar a mano.
    El botón de refrescar lo vuelve a calcular por si cambiaste el título
    después de haberlo tocado.

    Quita acentos, la ñ, símbolos y espacios dobles.
*/

export const onToSlug = (text = '') => (
    String(text)
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')   // saca acentos
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
);

export const FieldSlug = ({
    id, name, label = 'URL', hint, error,
    value = '', onChange, sourceValue = '',
    prefix = '/',
    isRequired = false, isDisabled = false,
    span = 1, ...rest
}) => {

    const onRegenerate = () => onChange?.({
        target: { name: name ?? id, value: onToSlug(sourceValue) },
    });

    const onHandleChange = (event) => onChange?.({
        ...event,
        target: { ...event.target, name: name ?? id, value: onToSlug(event.target.value) },
    });

    const DOM_NAME = useDomFieldName();

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span}
            isRequired={isRequired} isDisabled={isDisabled}
            hint={hint ?? `Quedará como ${prefix}${value || 'tu-titulo'}`} >

            <div className={`${BLOCK}__slug`}>

                <span className={`${BLOCK}__slug_prefix`}>
                    <FaLink aria-hidden="true" /> {prefix}
                </span>

                <input id={DOM_ID} data-field={name ?? id} name={DOM_NAME} type="text"
                    className={`${BLOCK}__input ${BLOCK}__slug_input`}
                    value={value} onChange={onHandleChange}
                    placeholder="mi-titulo"
                    required={isRequired} disabled={isDisabled}
                    autoComplete={FIELD_AUTOCOMPLETE_OFF}
                    aria-invalid={!!error}
                    {...rest} />

                <button type="button" className={`${BLOCK}__slug_button`}
                    aria-label="Regenerar desde el título"
                    disabled={isDisabled || !sourceValue}
                    onClick={onRegenerate} >
                    <FaSync />
                </button>

            </div>

        </FieldShell>
    );
};
